import { render, staticRenderFns } from "./ContactUs.vue?vue&type=template&id=2c24db59&scoped=true"
import script from "./ContactUs.vue?vue&type=script&lang=js"
export * from "./ContactUs.vue?vue&type=script&lang=js"
import style0 from "./ContactUs.vue?vue&type=style&index=0&id=2c24db59&prod&scoped=true&lang=scss"
import style1 from "./ContactUs.vue?vue&type=style&index=1&id=2c24db59&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c24db59",
  null
  
)

export default component.exports